import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=32c0ce0b&scoped=true&"
var script = {}
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=32c0ce0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0ce0b",
  null
  
)

export default component.exports